import { TCRSCartItem, TUser } from '@/domain/CRS.domain';
import { getLS } from '../storage/LocalStorage';
import { LS_CONTACT_INFO } from '../constants/variables';
import { TOrderCartItem } from '@/domain/Order.domain';
import { URLs } from '../constants/urls';
import { addWeeks } from 'date-fns';
import { TCartItem } from '@/domain/Cart.domain';
import { newDateFromString } from '../utils/getDateByTimezone';

export const createUserInfoData = (withEmail?: boolean) => {
    const { email, firstName, lastName, phone, phone2, userId } = getUser();

    return {
        ...(withEmail && { email }),
        ...(firstName && { firstName }),
        ...(lastName && { lastName }),
        ...(phone && { phone }),
        ...(phone2 && { phone2 }),
        ...(userId && { userId }),
    };
};

export const getUser = () => {
    const user: TUser | undefined = getLS(LS_CONTACT_INFO);

    return user || ({} as TUser);
};

export const res400Error = Promise.resolve({
    status: 400,
    data: { msg: 'Invalid email address' },
});

const createDate = (dateString: string, mode: 'arrival' | 'departure') => {
    const date =
        mode === 'departure'
            ? addWeeks(newDateFromString(dateString), 1)
            : newDateFromString(dateString);

    if (!date) {
        return 0;
    }

    const dateInSecs = Math.floor(date.getTime() / 1000);

    if (!dateInSecs) {
        return 0;
    }

    return dateInSecs;
};

export const createCRSOrderItems = (
    cartItems: TOrderCartItem[],
    partnerSlug: string
): TCRSCartItem[] => {
    try {
        return cartItems.map(({ id, trip_id, arrival_date, trip_name, subtotal }) => ({
            activityId: +trip_id,
            brand: partnerSlug,
            cartItemId: id,
            imageUrl: `${URLs.image}/activity/${trip_id}/center/676x489/wr.jpg`,
            url: `${URLs.domain}${partnerSlug}/details/${trip_id}`,
            name: trip_name,
            price: subtotal,
            arrivalDate: createDate(arrival_date, 'arrival'),
            departureDate: createDate(arrival_date, 'departure'),
        }));
    } catch (err) {
        if (process.env.NODE_ENV === 'development') {
            console.error(err);
        }
        return [];
    }
};

export const createCRSCartItems = (cartItems: TCartItem[], partnerSlug: string): TCRSCartItem[] => {
    try {
        return cartItems.map(
            ({ id, product_id, arrival_date, product_name, subtotal, partner_title }) => ({
                activityId: +product_id,
                brand: partner_title,
                cartItemId: id,
                imageUrl: `${URLs.image}/activity/${product_id}/center/676x489/wr.jpg`,
                url: `${URLs.domain}${partnerSlug}/details/${product_id}`,
                name: product_name,
                price: subtotal,
                arrivalDate: createDate(arrival_date, 'arrival'),
                departureDate: createDate(arrival_date, 'departure'),
            })
        );
    } catch (err) {
        if (process.env.NODE_ENV === 'development') {
            console.error(err);
        }
        return [];
    }
};
